import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import cns from '../../node_modules/classnames/index.js';
import Header from './Header.js';
import Body from './Body.js';
import Footer from './Footer.js';
import { existFixedColumns } from '../Utils/table.js';

/**
Le tabelle possono essere incorporate in una superficie, come una scheda o una card.
Le tabelle su card o schede possono avere strumenti di navigazione e di manipolazione dei dati in alto e in basso.
Possono essere editabili a seconda del contesto.
 */
const Table = function Table({ children, clickable, bordered, striped, hover, fixedLayout, className, }) {
    const fixed = useMemo(() => (fixedLayout !== undefined && fixedLayout !== null ? fixedLayout : existFixedColumns(children, Header.Column)), [children, fixedLayout]);
    return (jsx("table", { className: cns('table', {
            'table--bordered': bordered,
            'table--striped': striped,
            'table--hover': hover,
            'table--clickable': clickable,
            'table--fixed': fixed,
        }, className), children: children }));
};
Table.defaultProps = {
    bordered: false,
    children: null,
    className: '',
    clickable: false,
    hover: false,
    striped: false,
    fixedLayout: undefined,
};
Table.Head = Header;
Table.Body = Body;
Table.Foot = Footer;

export { Table as default };
